import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { call, put, takeEvery, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';
import { GET_COLLECTION_SUCCESS } from 'redux/collections/constants';
import { GET_PRODUCT_TEMPLATE_SUCCESS } from 'redux/productTemplates/constants';

import { listProducts, getProduct, getProductBySku } from './api';
import {
  LIST_PRODUCTS_REQUEST,
  GET_PRODUCT_REQUEST,
  GET_PRODUCT_BY_SKU_REQUEST,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_SUCCESS_GTM,
  PRODUCT_REQUESTING,
  LIST_PRODUCTS_SUCCESS,
  LIST_PRODUCTS_SUCCESS_GTM,
  RESET_PRODUCT_ISFETCHING
} from './constants';

export function* list(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: PRODUCT_REQUESTING });
    const response = yield call(
      listProducts,
      action.slug,
      cartId(),
      customerId(),
      action.qString,
      action.page
    );
    // listPayload(response.data);
    yield call(listPayload, response.data, action.viewType);
    // yield put({ type: LIST_PRODUCTS_SUCCESS_GTM, payload: response.data });
    // yield put({ type: LIST_PRODUCTS_SUCCESS, payload: response.data });
    // // Collections must be called second
    // yield put({ type: GET_COLLECTION_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: RESET_PRODUCT_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* listPayload(payload) {
  yield put({ type: LIST_PRODUCTS_SUCCESS_GTM, payload });
  yield put({ type: LIST_PRODUCTS_SUCCESS, payload });
  // Collections must be called second
  yield put({ type: GET_COLLECTION_SUCCESS, payload });
}

export function* get(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: PRODUCT_REQUESTING });
    const response = yield call(
      getProduct,
      action.slug,
      cartId(),
      customerId()
    );
    yield put({ type: GET_PRODUCT_SUCCESS_GTM, payload: response.data });
    if (response.data.productTemplate) {
      const template = {
        id: response.data.productTemplateId || 'default',
        content: response.data.productTemplate
      };
      yield put({ type: GET_PRODUCT_TEMPLATE_SUCCESS, payload: template });
    }
    yield put({ type: GET_PRODUCT_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: RESET_PRODUCT_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* getBySku(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: PRODUCT_REQUESTING });
    const response = yield call(
      getProductBySku,
      action.sku,
      cartId(),
      customerId()
    );
    yield put({ type: GET_PRODUCT_SUCCESS_GTM, payload: response.data });
    yield put({ type: GET_PRODUCT_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: RESET_PRODUCT_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* watchList() {
  // Need take latest so that gets multiple collections on a page
  yield takeEvery(LIST_PRODUCTS_REQUEST, list);
  yield takeEvery(GET_PRODUCT_REQUEST, get);
  yield takeEvery(GET_PRODUCT_BY_SKU_REQUEST, getBySku);
}

export default function* productSagas() {
  yield all([watchList()]);
}

const cartId = () => Cookies.get('cartId');
const customerId = () => {
  if (!Cookies.get('customerToken')) {
    return null;
  }
  return jwtDecode(Cookies.get('customerToken')).sub;
};
